import { useLocation } from "react-router-dom";

import { ROUTES } from "../../../routes";

export const useIsInternalUserCreatingAccount = (): boolean => {
  const location = useLocation();
  return location.pathname.includes(ROUTES.Dashboard.NewAccounts.path);
};
